<template>
  <div class="lad-filter--cities-content">
    <slot name="before-range" />

    <div class="wrapper-element-filter">
      <el-checkbox-group v-model="privateValues" v-infinite-scroll="load">
        <el-checkbox
          v-for="city in cities"
          :key="city.code"
          :label="city.code"
          >{{ city.name }}</el-checkbox
        >
      </el-checkbox-group>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LadFilterCity',
  props: {
    // eslint-disable-next-line vue/require-valid-default-prop
    values: { type: Array, default: [], required: true },
  },
  data() {
    return {
      base: 'filters',
      privateValues: [],
      count: 10,
    }
  },
  computed: {
    ...mapState('search', {
      cities(state) {
        return state.cities.slice(0, this.count)
      },
      total: (state) => state.cities.length,
    }),
  },
  watch: {
    values: {
      immediate: true,
      handler(newValue, oldValue) {
        this.privateValues = newValue
      },
    },
    privateValues(newValue, oldValue) {
      if (typeof oldValue !== 'undefined') {
        this.$emit('update-values', newValue)
      }
    },
  },
  methods: {
    load() {
      if (this.total > this.count) {
        this.count += 10
      }
    },
  },
}
</script>

<style lang="scss">
.lad-filter--cities-content {
  width: auto;

  .el-checkbox-group {
    height: 300px;
    max-height: 40vh;
    overflow-y: auto;
  }

  .el-checkbox {
    margin-right: 0;
    text-transform: capitalize;
    height: 25px;
  }
}
</style>
